import * as basedef from "./Interface";
import { parseMtl } from "../utils/MTLParser";

export class FileMessage extends basedef.Message{
    static type = "ps.file.FileMessage" as const;
    static version = 1 as const;
    data: File;
    transfer: boolean;
    constructor(data: File, transfer: boolean = false){
        super();
        this.data = data;
        this.transfer = transfer;
    }   
}

export class ArrayBufferMessage extends basedef.Message{
    static type = "ps.file.ArrayBufferMessage" as const;
    static version = 1 as const;
    data: ArrayBuffer 
    transfer: boolean;
    constructor(data: ArrayBuffer, transfer: boolean = false){
        super();
        this.data = data;
        this.transfer = transfer;
    }   
}

export function parseMTL(buffer: ArrayBuffer): any {
    let text = new TextDecoder().decode(buffer); // Check if buffer can be decoded as text, will throw if not
    return parseMtl(text);
}